import styled from 'styled-components/macro'

export default styled.div`
  display: flex;
  justify-content: center;
  background-color: rgba(${p => p.theme.color.primary}, 0.4);
  position: fixed;
  z-index: 10;
  width: 100%;
  padding: calc(${p => p.theme.spacing} * .5) 0;
  bottom: 0;
  left: 0;
`